import { BusMultipleIcon } from './BusMultipleIcon';

/**
 * author: Michael Richins
 * id E007EC1E-915B-4A12-89A0-8F7249AEF9FC
 * name bus-multiple
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bus-multiple.svg
 * tags
 * - Transportation + Road 
 */
export const FleetIcon = BusMultipleIcon;
export default FleetIcon